import { Table } from "semantic-ui-react";
import React from "react";
import "../../utils/stylesheet.css";
import { AreaTableRow } from "./AreaTableRow";
import { NoRecords } from "../../common/components/NoRecords";
import { useAuth } from "../../utils/Auth";

export const AreaTable = ({ areas, reload, active = true }) => {
  const { user } = useAuth();

  if (areas.length === 0) {
    return (
      <NoRecords iconName="briefcase" message="Não encontramos nenhuma área!" />
    );
  }

  let rows = areas.map((area) => (
    <AreaTableRow key={area.id} area={area} reload={reload} active={active} />
  ));

  return (
    <Table selectable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Código</Table.HeaderCell>
          <Table.HeaderCell>Área</Table.HeaderCell>
          <Table.HeaderCell>Área pai</Table.HeaderCell>
          {active && (
            <Table.HeaderCell>Quantidade de funcionários</Table.HeaderCell>
          )}
          {(user.active_employee
            ? user.active_employee._extra.is_superuser
            : user.is_superuser) &&
            active && <Table.HeaderCell>Ações</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};
